import BaseComponent from "../BaseComponent";

const { ccclass, property, help, menu } = cc._decorator;

/**
 * 长按功能组件
 */
@ccclass
@menu('Framework/交互组件/LongPressFun')
export default class LongPressFun extends BaseComponent {
	 /** 长按或点击回调 */
	 @property({
        type: cc.Component.EventHandler,
        tooltip: CC_DEV && '长按或点击回调',
    })
	private longPressEvent: cc.Component.EventHandler = new cc.Component.EventHandler();

    @property({
        tooltip: CC_DEV && '长按增长间隔',
    })
    longTouchTimeSpace: number = 0.15;

    @property({
        tooltip: CC_DEV && '第一次触发时间',
    })
    firstTriggerTime: number = 1;

	private bTouch = false;
	private useSpaceTime = 0;
	private firstTouchTime = 0;
	private bYetUse = false;
	// private callfun: Function = null;
	/**
	 * 生命周期：加载
	 */
	onLoad() {
        super.onLoad();
		this.initTouchEvent(this.node);
	}

	// setCallback(callfun: Function) {
	// 	this.callfun = callfun;
	// }

	touchEventStart(event: cc.Event.EventTouch){
		this.bTouch = true;
    }
	
	touchEventEnd(event: cc.Event.EventTouch){
        if (this.bTouch && !this.bYetUse) {
            this.useFun();
        }
        this.resetTouchData();
    }

    touchEventCancel(event: cc.Event.EventTouch){
		this.resetTouchData();
    }

	resetTouchData() {
        this.firstTouchTime = 0;
        this.bYetUse = false;
        this.useSpaceTime = 0;
        this.bTouch = false;
    }

	useFun(...params: any[]) {
		// if (this.callfun) {
		// 	this.callfun();
		// }
		cc.Component.EventHandler.emitEvents(
            [this.longPressEvent]
            , this
            , ...params
        );
	}

	update (dt: number) {
		if (!this.bTouch) {
			return;
		}
		
        if (this.firstTouchTime < this.firstTriggerTime) {
            this.firstTouchTime += dt;
            return;
        }
        if (!this.bYetUse) {
            this.bYetUse = true;
            this.useFun();
            return;
        }
        this.useSpaceTime += dt;
        if (this.useSpaceTime < this.longTouchTimeSpace) {
            return;
        }
        this.useSpaceTime = 0;
        this.useFun();
	}

}
